import { Injectable } from '@angular/core';
import { CategoryService, CategoryTree } from '@sgm-frontend/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { shareReplay, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CategoryGlobalService {

  private categoriesSubject = new BehaviorSubject<CategoryTree[]>([]);
  categories$ = this.categoriesSubject.asObservable();

  constructor(private categoriesService: CategoryService) {}

  loadCategories(): Observable<any> {
    return this.categoriesService.getAllCategoriesTree().pipe(
      tap((x) => {
        this.categoriesSubject.next(x);

        
      }),
      shareReplay({ bufferSize: 1, refCount: true })
    );
  }

   getBreadcrumbBySlug(slug: string): CategoryTree[] {
    const tree = this.categoriesSubject.value;
    const path: CategoryTree[] = [];

    const findPath = (categories: CategoryTree[], slug: string): boolean => {
      for (const cat of categories) {
        path.push(cat);

        if (cat.slug === slug) {
          return true;
        }

        if (cat.children && findPath(cat.children, slug)) {
          return true;
        }

        path.pop();
      }

      return false;
    };

    findPath(tree, slug);
    return path;
  }


}